import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import {
  AdaptivePlannerBacklogItemApi,
  type BacklogItemFilters,
} from '@/lib/api/adaptive-planner/backlog-item';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

export const backlogItemsDataSetFetchOptions = ({
  planId,
  filters,
}: {
  planId: number;
  filters?: BacklogItemFilters;
}) => {
  return queryOptions({
    queryKey: adaptivePlannerQueryKeys.backlogItems.dataSet({ planId, filters }),
    queryFn: () =>
      AdaptivePlannerBacklogItemApi.fetchBacklogItemsDataSet({
        planId,
        filters,
      }),
  });
};

export const useBacklogItemsDataSetQuery = ({
  planId,
  filters,
  enabled = true,
}: {
  planId: number;
  filters?: BacklogItemFilters;
  enabled?: boolean;
}) => {
  return useQuery({
    ...backlogItemsDataSetFetchOptions({ planId, filters }),
    enabled,
  });
};

export const useBacklogItemsDataSetSuspenseQuery = ({
  planId,
  filters,
}: {
  planId: number;
  filters?: BacklogItemFilters;
}) => {
  return useSuspenseQuery(backlogItemsDataSetFetchOptions({ planId, filters }));
};
